<template>
  <v-card>
    <v-card-title>
      <router-link
        :to="{ name: 'pef_diary_add' }"
        v-if="['PEF'].includes(current_user.role)"
      >
        <v-btn fab class="mt-n4" :color="color">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </router-link>

      <p class="pl-6">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/journal.png"
            :aspect-ratio="1"
            width="40"
          />{{ $tc("diaries.pef", 2) }}</v-row
        >
      </p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="pef_diaries"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="$store.state.pef_diary.totalCount"
      dense
      show-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pt-5" :colspan="headers.length">
          <p>
            <span class="font-weight-bold">{{ $t("diaries.comment") }}:</span>
            {{ item.comment | capitalize }}
          </p>
          <div>
            <span class="font-weight-bold">{{ $t("diaries.learning") }}:</span>
            <p class="pre-formatted">{{ item.learning | capitalize }}</p>
          </div>
          <div>
            <span class="font-weight-bold"
              >{{ $t("diaries.observation.display") }}:</span
            >
            <p class="pre-formatted">{{ item.observations | capitalize }}</p>
          </div>
        </td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.actions="{ item }">
        <v-btn small icon @click.prevent="remove('pef_diary', item)">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
      <template #item.comment="{ item }">
        {{ item.comment | truncate(10) }}
      </template>
      <template #item.learning="{ item }">
        {{ item.learning | truncate(10) }}
      </template>
      <template #item.date="{ item }">
        {{ item.date | date }}
      </template>
      <template #item.actions="{ item }">
        <span v-if="!['PEF', 'ASPIRANT'].includes(current_user.role)">
          <v-icon
            style="cursor: pointer"
            class="mr-2"
            @click="openObservations(item)"
            >mdi-comment-eye-outline</v-icon
          >
        </span>
        <edit-delete
          v-if="['PEF'].includes(current_user.role)"
          :edit-path="{
            name: 'pef_diary_form_edit',
            params: { diary_id: item.id },
          }"
          @delete="remove('pef_diary', item)"
        />
      </template>
    </v-data-table>
    <v-dialog v-model="observationsDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("diaries.observation.title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12">
              <p class="font-weight-bold">
                {{ $t("diaries.observation.desc") }}
              </p>
              <v-row>
                <v-textarea
                  v-model="observation"
                  :label="$t('diaries.observation.title')"
                  required
                />
              </v-row>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="observationsDialog = false">
            {{ $t("common.close") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveObservation">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH, UPDATE } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"

const { mapActions } = createNamespacedHelpers("pef_diary")

export default {
  name: "PefDiaryTable",
  components: { EditDelete },
  mixins: [TableMixin],
  data: () => ({
    observationsDialog: false,
    observation: "",
    observationItem: "",
  }),
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    pef_diaries() {
      return this.$store.state.pef_diary.data
    },

    headers() {
      return [
        {
          value: "date",
          text: this.$tc("common.date", 1),
          align: " text-no-wrap",
        },
        {
          value: "comment",
          text: this.$t("diaries.comment"),
          width: "32%",
        },
        {
          value: "learning",
          text: this.$t("diaries.learning"),
          width: "32%",
        },
        {
          value: "actions",
          align: "right",
          width: "4%",
        },
      ]
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([FETCH, UPDATE]),
    openObservations(item) {
      this.observationsDialog = true
      this.observationItem = item
      this.observation = item.observations
    },
    saveObservation() {
      this.loading = true
      this.UPDATE({
        id: this.observationItem.id,
        observations: this.observation,
      }).then(
        async () => {
          this.loading = false
          await this.$toast.success(this.$t("common.success_edit"))
          this.observationsDialog = false
        },
        () => {
          this.loading = false
        }
      )

      this.loading = false
    },
  },
}
</script>
